import React from 'react'
import styles from './Footer.module.scss'
import { withTranslation } from 'react-i18next'

const Footer = ({ t, i18n }) => {
  return i18n.language === 'en' ? (
    <footer id="footer" className={['footer', styles['footer']].join(' ')} role="contentinfo">
      <div className="container">
        <div aria-label="copyright" className="copyright">
          {/* <ul className="remove-underline">
            <li>
              <a target="_blank" rel="noopener noreferrer" href="http://novascotia.ca/news/rss/" className="nsgov_rss_anchor">
                RSS
                <span className="ns-visually-hidden">(opens in a new tab)</span>
              </a>
            </li>
            <li>
              <a target="_blank" rel="noopener noreferrer" href="https://www.twitter.com/nsgov" className="nsgov_twitter_anchor">
                Twitter
                <span className="ns-visually-hidden">(opens in a new tab)</span>
              </a>
            </li>
            <li>
              <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/nsgov" className="nsgov_youtube_anchor">
                Youtube
                <span className="ns-visually-hidden">(opens in a new tab)</span>
              </a>
            </li>
            <li>
              <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/nsgov" className="nsgov_facebook_anchor">
                Facebook
                <span className="ns-visually-hidden">(opens in a new tab)</span>
              </a>
            </li>
          </ul> */}

          <ul className="remove-underline">
            <li>
              <a
                style={{ textDecoration: 'none' }}
                target="_blank"
                rel="noopener noreferrer"
                href="http://novascotia.ca/cns/privacy/"
                className="nsgov_privacy_anchor"
              >
                Privacy
                <span className="ns-visually-hidden">(opens in a new tab)</span>
              </a>
            </li>
            <li>
              <a
                style={{ textDecoration: 'none' }}
                target="_blank"
                rel="noopener noreferrer"
                href="http://novascotia.ca/terms/"
                className="nsgov_terms_anchor"
              >
                Terms
                <span className="ns-visually-hidden">(opens in a new tab)</span>
              </a>
            </li>
            <li>
              <a
                style={{ textDecoration: 'none' }}
                target="_blank"
                rel="noopener noreferrer"
                href="http://novascotia.ca/cns/privacy/cookies/"
                className="nsgov_cookies_anchor"
              >
                Cookies
                <span className="ns-visually-hidden">(opens in a new tab)</span>
              </a>
            </li>
          </ul>

          {/* <div>
            <small>
              Crown copyright © Province of <span className="word-break-together">Nova Scotia.</span>
            </small>
          </div> */}
        </div>
      </div>
    </footer>
  ) : (
    <footer id="footer" className={['footer', styles['footer']].join(' ')} role="contentinfo">
      <div className="container">
        {/* <ul aria-label="Social media links" className="footer-social-links" lang="fr">
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.twitter.com/nsgov"
              className="nsgov_twitter_anchor"
              hrefLang="fr"
            >
              Twitter
              <span className="ns-visually-hidden">(opens in a new tab)</span>
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.youtube.com/nsgov"
              className="nsgov_youtube_anchor"
              hrefLang="fr"
            >
              YouTube
              <span className="ns-visually-hidden">(opens in a new tab)</span>
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.facebook.com/nsgov"
              className="nsgov_facebook_anchor"
              hrefLang="fr"
            >
              Facebook
              <span className="ns-visually-hidden">(opens in a new tab)</span>
            </a>
          </li>
        </ul> */}
        <ul className="footer-statement-links">
          <li>
            <a
              style={{ textDecoration: 'none' }}
              target="_blank"
              rel="noopener noreferrer"
              href="https://beta.novascotia.ca/fr/enonce-de-confidentialite"
              className="nsgov_privacy_anchor_fr"
            >
              Confidentialité
              <span className="ns-visually-hidden">(opens in a new tab)</span>
            </a>
          </li>
          <li>
            <a
              style={{ textDecoration: 'none' }}
              target="_blank"
              rel="noopener noreferrer"
              href="https://beta.novascotia.ca/fr/conditions-dutilisation"
              className="nsgov_terms_anchor_fr"
            >
              Modalités
              <span className="ns-visually-hidden">(opens in a new tab)</span>
            </a>
          </li>
          <li>
            <a
              style={{ textDecoration: 'none' }}
              target="_blank"
              rel="noopener noreferrer"
              href="https://novascotia.ca/sns/services/help/cookies-fr.asp"
              className="nsgov_cookies_anchor_fr"
            >
              Témoins
              <span className="ns-visually-hidden">(opens in a new tab)</span>
            </a>
          </li>
        </ul>
        {/* <div aria-label="copyright" className="copyright">
          <small>Droit d'auteur de la Couronne ©, Province de la Nouvelle-Écosse</small>
        </div> */}
      </div>
    </footer>
  )
}

export default withTranslation('common')(Footer)
